import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import { buttonClasses } from "@/components/design/button-classes";
import type { PowerQuizState } from "./use-power-quiz-status";

export function PowerQuizButton({ status }: { status: PowerQuizState | null }) {
  if (!status || status.complete) return null;
  return (
    <Link
      id="grow-power-quiz-action"
      to={`/grow/play/group/${status.questionnaireGroupId}`}
      className={buttonClasses({ variant: "secondary", size: "compact" })}
    >
      {status.started ? (
        <FormattedMessage id="grow.powerDetail.quiz.continue" defaultMessage="Continue Power Quiz" />
      ) : (
        <FormattedMessage id="grow.powerDetail.quiz.start" defaultMessage="Start Power Quiz" />
      )}
    </Link>
  );
}
